import React from "react";
import styles from "./CardList.module.css";

const TransactionCardSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div
          className={styles.skeleton}
          style={{ width: "7.5rem", height: "1rem" }}
        />
        <div
          className={styles.skeleton}
          style={{
            width: "3.75rem",
            height: "1.5rem",
            borderRadius: "0.25rem",
          }}
        />
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>From:</span>
          <div
            className={styles.skeleton}
            style={{ width: "9.375rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>To:</span>
          <div
            className={styles.skeleton}
            style={{ width: "9.375rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Value:</span>
          <div
            className={styles.skeleton}
            style={{ width: "6.25rem", height: "0.875rem" }}
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionCardSkeleton;
